import { ProviderInfo, ProviderProgramTaxonomy } from '../../models/providers/Providers'
import { TREATMENT_OPTIONS, TREATMENT_OPTIONS_TYPE } from '../common/constants/treatmentOptions'
import { findProviderCTPOForTreatmentOption } from './treatmentOptionProgramTaxonomyMappings'

type MedicationSearchProgram = {
  treatmentOption: TREATMENT_OPTIONS_TYPE
  taxonomy: ProviderProgramTaxonomy
}

export function resolveMedicationSearchProgram(
  provider?: Pick<ProviderInfo, 'program_taxonomy' | 'eligibleMedicationTreatmentOptions'> | null,
): MedicationSearchProgram | undefined {
  const eligibleOptions = provider?.eligibleMedicationTreatmentOptions
  if (!eligibleOptions?.length) return undefined

  // Prototype policy shared with LW-API: prefer LMM when both programs are eligible and offered.
  for (const treatmentOption of [TREATMENT_OPTIONS.BLENDED_CARE_MEDS, TREATMENT_OPTIONS.DIRECT_ACCESS_MEDS]) {
    if (!eligibleOptions.includes(treatmentOption)) continue
    const taxonomy = findProviderCTPOForTreatmentOption(treatmentOption, provider?.program_taxonomy)
    if (taxonomy) return { treatmentOption, taxonomy }
  }
  throw new Error('Combined medication search provider has no eligible medication program')
}
